import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/FirebaseAuthContext';
import Logo from '../../components/ui/Logo';

const OnboardingComplete: React.FC = () => {
  const navigate = useNavigate();
  const { userPreferences } = useAuth();

  const handleStartReading = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-[#fcfaf3] flex flex-col items-center pt-12">
      <Logo />
      <div className="mt-12 flex flex-col items-center w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mb-6">
            <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2 text-center">You're all set!</h1>
          <p className="text-base text-gray-600 text-center">Your Smata experience is now personalized and ready to go</p>
        </div>
        <div className="bg-[#FFECE7] rounded-xl p-6 w-full mb-8 flex flex-col items-start">
          <div className="flex items-center mb-2">
            <svg className="w-5 h-5 text-[#FF6600] mr-2" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span className="font-semibold text-base text-gray-900">Your goal summary</span>
          </div>
          <ul className="list-disc pl-6 text-gray-800 text-base">
            <li>Reading preferences: {userPreferences?.genres.map(genre => genre.charAt(0).toUpperCase() + genre.slice(1)).join(', ')}</li>
            <li>Read {userPreferences?.goals.booksPerYear} books this year</li>
          </ul>
        </div>
        <button
          onClick={handleStartReading}
          className="w-full max-w-lg py-4 rounded-full bg-[#232323] text-white font-semibold text-lg shadow-sm hover:bg-[#111] transition mt-2"
          style={{letterSpacing: 0.2}}
        >
          Start Reading
        </button>
      </div>
    </div>
  );
};

export default OnboardingComplete; 